import { useSelector } from 'react-redux';
import { flatten } from 'ramda';
import { useParams } from 'react-router';
import { useMemo } from 'react';
import moment from 'moment';
import { newspapersStateSelector } from '../store/newspapers/newspapersSelectors';
import { appGlobalDataSelectedCriteriaSelector, appGlobalDataSelectedNewsGroupSelector, } from '../store/appGlobalData/appGlobalDataSelectors';
import newsGroupsStateEntitiesSelector from '../store/newsGroups/newsGroupsSelectors';
/**
 * A custom hook that returns an array of newspapers based on the various
 * selection criteria available in the global state
 */
var useSelectedNewspapers = function () {
    var _a = useSelector(newspapersStateSelector), loading = _a.loading, data = _a.data;
    var selectedCriteria = useSelector(appGlobalDataSelectedCriteriaSelector);
    var selectedNewsGroup = useSelector(appGlobalDataSelectedNewsGroupSelector);
    var newsGroups = useSelector(newsGroupsStateEntitiesSelector);
    var date = useParams().date;
    // If there are selected criteria (i.e. if user has selected a newspaper), we only return the data in the state,
    // which will exist of all newspapers of the same publication in one month.
    // Else, we want to filter on the selected news group (since there is ALWAYS an active selection).
    // We do this by filtering newspapers on the newspaper ids belonging to the selected news group.
    var currentDay = useMemo(function () {
        return moment("" + (date === null || date === void 0 ? void 0 : date.slice(4, 8)) + (date === null || date === void 0 ? void 0 : date.slice(2, 4)) + (date === null || date === void 0 ? void 0 : date.slice(0, 2))).day();
    }, [date]);
    var selectedNewspapers = selectedCriteria ? data
        : flatten(newsGroups
            .filter(function (group) { return (currentDay === 0 && selectedNewsGroup === "politikes") ? (group.id !== "athlitikes") : group.id === selectedNewsGroup; })
            .map(function (group) { return data.filter(function (newspaper) { return newspaper.publicationId && group.newspaperIds.includes(newspaper.publicationId); }); }));
    return [loading, selectedNewspapers];
};
export default useSelectedNewspapers;
